export default __webpack_public_path__ + "static/media/Gilroy-Medium.0d9db8eb.woff2";